// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__GV-au","label":"CategoryService_label__2KHip","location":"CategoryService_location__L2Hvh"};